import App from './App';
import i18n from './i18n';
import './index.css';
import { capturePwaInstallPrompt } from './pwa/install-prompt';
import { registerPwaLaunchHandler } from './pwa/launch-handler';
import { registerRewardBloomServiceWorker } from './pwa/register-service-worker';
import ReactDOM from 'react-dom/client';

capturePwaInstallPrompt();
registerPwaLaunchHandler();
registerRewardBloomServiceWorker();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error(i18n.t('ERRORS.ROOT_ELEMENT_NOT_FOUND'));
}

ReactDOM.createRoot(rootElement).render(<App />);
